import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 m-3"
}
const _hoisted_2 = { class: "assets-grid-card" }
const _hoisted_3 = { class: "assets-grid-card__header" }
const _hoisted_4 = { class: "assets-grid-title" }
const _hoisted_5 = { class: "assets-grid-title__text" }
const _hoisted_6 = { class: "assets-grid-controls" }
const _hoisted_7 = { class: "assets-grid-card__body" }
const _hoisted_8 = { class: "wl-assets-search-wrap" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  key: 0,
  class: "wp-grid-wrap"
}
const _hoisted_11 = {
  key: 0,
  class: "wp-loading wp-loading--overlay"
}
const _hoisted_12 = { class: "wp-loading__text" }
const _hoisted_13 = { class: "text-muted small" }
const _hoisted_14 = { class: "text-muted small font-monospace" }
const _hoisted_15 = { class: "text-muted small font-monospace" }
const _hoisted_16 = { class: "wl-row-actions" }
const _hoisted_17 = ["title", "onClick"]
const _hoisted_18 = ["title", "onClick"]
const _hoisted_19 = { class: "assets-grid-card ni-grid-card--spaced" }
const _hoisted_20 = { class: "assets-grid-card__header" }
const _hoisted_21 = { class: "assets-grid-title" }
const _hoisted_22 = { class: "assets-grid-title__text" }
const _hoisted_23 = { class: "assets-grid-card__body" }
const _hoisted_24 = { class: "wl-assets-search-wrap" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = {
  key: 0,
  class: "wp-grid-wrap"
}
const _hoisted_27 = {
  key: 0,
  class: "wp-loading wp-loading--overlay"
}
const _hoisted_28 = { class: "wp-loading__text" }
const _hoisted_29 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_30 = { class: "text-muted small font-monospace" }
const _hoisted_31 = { class: "text-muted small font-monospace" }
const _hoisted_32 = { class: "wl-row-actions" }
const _hoisted_33 = ["title", "onClick"]
const _hoisted_34 = { class: "assets-grid-title" }
const _hoisted_35 = { class: "assets-grid-title__text" }
const _hoisted_36 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mb-3"
}
const _hoisted_37 = { class: "mb-0" }
const _hoisted_38 = { class: "d-flex justify-content-between w-100" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.error), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
            _createElementVNode("i", { class: "bi bi-diagram-3-fill" })
          ], -1)),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('components.infrastructure.anchorPlacement.sections.withScheme')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "assets-toolbar-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToCreate()))
          }, [
            _cache[7] || (_cache[7] = _createElementVNode("i", { class: "bi bi-plus-circle" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.anchorPlacement.addScheme')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.schemeSearch) = $event)),
            type: "text",
            class: "form-control wl-assets-search",
            placeholder: _ctx.$t('components.infrastructure.anchorPlacement.searchPlaceholder')
          }, null, 8, _hoisted_9), [
            [_vModelText, _ctx.schemeSearch]
          ])
        ]),
        (_ctx.hasActivated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_ctx.dataLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[8] || (_cache[8] = _createElementVNode("span", {
                      class: "spinner-border wp-loading__spinner",
                      role: "status"
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('components.infrastructure.loading')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_DxDataGrid, {
                class: "ni-grid",
                "data-source": _ctx.filteredSchemeRows,
                "key-expr": "id",
                "hover-state-enabled": true,
                "column-auto-width": false,
                "show-borders": false,
                "show-column-lines": false,
                "show-row-lines": false,
                "row-alternation-enabled": true,
                "column-hiding-enabled": _ctx.isNarrowViewport,
                "word-wrap-enabled": true,
                "no-data-text": _ctx.$t('components.infrastructure.anchorPlacement.empty')
              }, {
                "location-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(data.data.groupName), 1)
                ]),
                "anchors-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(data.data.anchorMarkerCount) + " (" + _toDisplayString(data.data.anchorAvailable) + ")", 1)
                ]),
                "assets-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(data.data.assetMarkerCount) + " (" + _toDisplayString(data.data.assetAvailable) + ")", 1)
                ]),
                "actions-template": _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "wl-row-action",
                      title: _ctx.$t('components.infrastructure.anchorPlacement.edit'),
                      onClick: _withModifiers(($event: any) => (_ctx.openAnchorEditor(data.data)), ["stop"])
                    }, [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("i", { class: "bi bi-pencil-square" }, null, -1)
                    ]))], 8, _hoisted_17),
                    _createElementVNode("button", {
                      type: "button",
                      class: "wl-row-action wl-row-action--danger",
                      title: _ctx.$t('components.infrastructure.anchorPlacement.deleteScheme'),
                      onClick: _withModifiers(($event: any) => (_ctx.openDeleteConfirm(data.data)), ["stop"])
                    }, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("i", { class: "bi bi-trash" }, null, -1)
                    ]))], 8, _hoisted_18)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_DxLoadPanel, { enabled: false }),
                  _createVNode(_component_DxPaging, { "page-size": 10 }),
                  _createVNode(_component_DxPager, {
                    "allowed-page-sizes": [10, 20, 50],
                    "show-info": true,
                    "show-page-size-selector": true,
                    "show-navigation-buttons": true
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "name",
                    caption: _ctx.$t('components.infrastructure.anchorPlacement.columns.name'),
                    "min-width": 160,
                    "allow-sorting": false
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "groupName",
                    caption: _ctx.$t('components.infrastructure.anchorPlacement.columns.location'),
                    "min-width": 180,
                    "allow-sorting": false,
                    "cell-template": "location-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "anchorMarkerCount",
                    caption: _ctx.$t('components.infrastructure.anchorPlacement.columns.anchors'),
                    alignment: "center",
                    width: "150",
                    "allow-sorting": false,
                    "hiding-priority": 1,
                    "cell-template": "anchors-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "assetMarkerCount",
                    caption: _ctx.$t('components.infrastructure.anchorPlacement.columns.assets'),
                    alignment: "center",
                    width: "150",
                    "allow-sorting": false,
                    "hiding-priority": 0,
                    "cell-template": "assets-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    caption: _ctx.$t('components.infrastructure.anchorPlacement.columns.actions'),
                    width: "110",
                    "allow-filtering": false,
                    "allow-sorting": false,
                    "cell-template": "actions-template"
                  }, null, 8, ["caption"])
                ]),
                _: 1
              }, 8, ["data-source", "column-hiding-enabled", "no-data-text"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
            _createElementVNode("i", { class: "bi bi-geo-alt-fill" })
          ], -1)),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('components.infrastructure.anchorPlacement.sections.withoutScheme')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.locationSearch) = $event)),
            type: "text",
            class: "form-control wl-assets-search",
            placeholder: _ctx.$t('components.infrastructure.anchorPlacement.searchLocationPlaceholder')
          }, null, 8, _hoisted_25), [
            [_vModelText, _ctx.locationSearch]
          ])
        ]),
        (_ctx.hasActivated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              (_ctx.dataLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _cache[12] || (_cache[12] = _createElementVNode("span", {
                      class: "spinner-border wp-loading__spinner",
                      role: "status"
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('components.infrastructure.loading')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_DxDataGrid, {
                class: "ni-grid",
                "data-source": _ctx.filteredLocationRows,
                "key-expr": "id",
                "hover-state-enabled": true,
                "column-auto-width": false,
                "show-borders": false,
                "show-column-lines": false,
                "show-row-lines": false,
                "row-alternation-enabled": true,
                "word-wrap-enabled": true,
                "no-data-text": _ctx.$t('components.infrastructure.anchorPlacement.emptyLocations')
              }, {
                "loc-name-template": _withCtx(({ data }) => [
                  _createElementVNode("span", null, _toDisplayString(data.data.name), 1),
                  (data.data.city)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, " · " + _toDisplayString(data.data.city), 1))
                    : _createCommentVNode("", true)
                ]),
                "loc-anchors-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_30, _toDisplayString(data.data.anchorSelected) + " (" + _toDisplayString(data.data.anchorAvailable) + ")", 1)
                ]),
                "loc-assets-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_31, _toDisplayString(data.data.assetSelected) + " (" + _toDisplayString(data.data.assetAvailable) + ")", 1)
                ]),
                "loc-actions-template": _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "wl-row-action",
                      title: _ctx.$t('components.infrastructure.anchorPlacement.edit'),
                      onClick: _withModifiers(($event: any) => (_ctx.goToCreate(data.data)), ["stop"])
                    }, [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("i", { class: "bi bi-pencil-square" }, null, -1)
                    ]))], 8, _hoisted_33)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_DxLoadPanel, { enabled: false }),
                  _createVNode(_component_DxPaging, { "page-size": 10 }),
                  _createVNode(_component_DxPager, {
                    "allowed-page-sizes": [10, 20, 50],
                    "show-info": true,
                    "show-page-size-selector": true,
                    "show-navigation-buttons": true
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "name",
                    caption: _ctx.$t('components.infrastructure.anchorPlacement.columns.locationName'),
                    "min-width": 220,
                    "allow-sorting": false,
                    "cell-template": "loc-name-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "anchorAvailable",
                    caption: _ctx.$t('components.infrastructure.anchorPlacement.columns.anchors'),
                    alignment: "center",
                    width: "150",
                    "allow-sorting": false,
                    "hiding-priority": 1,
                    "cell-template": "loc-anchors-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "assetAvailable",
                    caption: _ctx.$t('components.infrastructure.anchorPlacement.columns.assets'),
                    alignment: "center",
                    width: "150",
                    "allow-sorting": false,
                    "hiding-priority": 0,
                    "cell-template": "loc-assets-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    caption: _ctx.$t('components.infrastructure.anchorPlacement.columns.actions'),
                    width: "90",
                    "allow-filtering": false,
                    "allow-sorting": false,
                    "cell-template": "loc-actions-template"
                  }, null, 8, ["caption"])
                ]),
                _: 1
              }, 8, ["data-source", "no-data-text"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_base_modal, {
      ref: "deleteModalRef",
      size: "md",
      "center-top": true
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_34, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
            _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" })
          ], -1)),
          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('components.infrastructure.anchorPlacement.confirmDeleteTitle')), 1)
        ])
      ]),
      body: _withCtx(() => [
        (_ctx.deleteError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.deleteError), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.schemeToDelete ? _ctx.$t('components.infrastructure.anchorPlacement.confirmDeleteScheme', { name: _ctx.schemeToDelete.name }) : ''), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteConfirm && _ctx.closeDeleteConfirm(...args)))
          }, _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.close')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-danger",
            disabled: _ctx.deleting,
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.confirmDeleteScheme && _ctx.confirmDeleteScheme(...args)))
          }, [
            (_ctx.deleting)
              ? (_openBlock(), _createElementBlock("span", _hoisted_40))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('components.infrastructure.anchorPlacement.confirmDeleteButton')), 1)
          ], 8, _hoisted_39)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}